import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { cart } = useCart();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Doctor' },
    { path: '/products', label: 'Products' },
    { path: '/contact', label: 'Contact' },
    { path: '/disclaimer', label: 'Disclaimer' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-cream shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo - Made Larger */}
          <Link to="/" className="flex items-center space-x-3" data-testid="header-logo">
            <img 
              src="/images/logo.png" 
              alt="Amrita Sparsha Logo" 
              className="h-20 w-auto md:h-24"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
                className={`text-sm font-medium transition-colors hover:text-golden ${
                  isActive(link.path) ? 'text-golden border-b-2 border-golden' : 'text-dark-text'
                }`}
              >
                {link.label}
              </Link>
            ))}
            
            {/* Cart Icon */}
            <Link 
              to="/cart" 
              className="relative"
              data-testid="cart-icon"
            >
              <ShoppingCart size={24} className="text-golden hover:text-dark-text transition-colors" />
              {cart.total_items > 0 && (
                <span 
                  className="absolute -top-2 -right-2 bg-golden text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold"
                  data-testid="cart-count"
                >
                  {cart.total_items}
                </span>
              )}
            </Link>
          </nav>

          {/* Mobile Menu Button & Cart */}
          <div className="md:hidden flex items-center gap-4">
            <Link to="/cart" className="relative" data-testid="mobile-cart-icon">
              <ShoppingCart size={24} className="text-golden" />
              {cart.total_items > 0 && (
                <span className="absolute -top-2 -right-2 bg-golden text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                  {cart.total_items}
                </span>
              )}
            </Link>
            
            <button
              data-testid="mobile-menu-button"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-golden"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(' ', '-')}`}
                className={`block py-2 px-4 rounded transition-colors ${
                  isActive(link.path)
                    ? 'bg-golden text-white'
                    : 'text-dark-text hover:bg-light-gold'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;